import * as Ladda from 'ladda';
import { Forms } from 'forms';


export default class Utils {
    static inputEscape(text) {
        if (typeof text === 'undefined' || typeof text === 'number' || text === null) {
            return text;
        }

        return text.replace(/"/g, '&quot;');
    }

    static textareaEscape(text) {
        if (typeof text === 'undefined' || typeof text === 'number' || text === null) {
            return text;
        }
        return text.replace(/\r\n|\r|\n/gm, '&#013;&#010;');
    }


    static printHtml(title, html) {
        const mywindow = window.open('', title, 'height=800,width=1024');
        mywindow.document.write(`<html><head><title>${title}</title>`);
        mywindow.document.write($('<div>').append($('link[rel="stylesheet"]').clone()).html());
        mywindow.document.write(`</head><body class="${$('body').attr('class')}">`);
        mywindow.document.write(html);
        mywindow.document.write('</body></html>');

        $(mywindow.document).ready(() => {
            setTimeout(() => {
                mywindow.document.close(); // necessary for IE >= 10
                mywindow.focus(); // necessary for IE >= 10

                mywindow.print();
                mywindow.close();
            }, 1000);
        });
    }


    static numberWithSep(x, sep) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    }


    static roundPlaces(number, places) {
        const multiplier = parseInt('1'.padEnd(places + 1, '0'), 10);
        return Math.round(number * multiplier) / multiplier;
    }


    static isKeyCodeValidInput(keycode) {
        const valid = (keycode > 47 && keycode < 58) // number keys
            || keycode === 32 /* || keycode === 13 */ // spacebar & return key(s)
            || keycode === 8 || keycode === 46 // Backspace & delete
            || (keycode > 64 && keycode < 91) // letter keys
            || (keycode > 95 && keycode < 112) // numpad keys
            || (keycode > 185 && keycode < 193) // ;=,-./` (in order)
            || (keycode > 218 && keycode < 223); // [\]' (in order)

        return valid;
    }

    // Bootbox
    static bootboxLaddaButton(box) {
        const acceptButton = box.find('.bootbox-accept');
        let acceptButtonLadda = null;
        if (acceptButton.length > 0) {
            Forms.makeLaddaButton(acceptButton);
            acceptButtonLadda = Ladda.create(acceptButton[0]);
        }

        return acceptButtonLadda;
    }

    // Show Alert
    static showAlert(title, text, type) {
        const customType = (!type ? 'info' : type);

        mainModule.bootbox.alert({
            title,
            message: text,
            closeButton: false,
            buttons: {
                ok: {
                    className: `btn-${customType}`,
                },
            },
        });
    }

    // Show Confirm
    static showConfirm(title, text, cCallback, type) {
        const customType = (!type ? 'info' : type);
        let box = null;
        const callbackFn = function callbackFn(success) {
            if (typeof cCallback === 'function') {
                cCallback(success, box);
            }
        };
        box = mainModule.bootbox.confirm({
            title,
            message: text,
            closeButton: false,
            callback: callbackFn,
            buttons: {
                confirm: {
                    className: `btn-${customType}`,
                },
            },
        });
    }

    // Select element
    static selectElementContents(el) {
        const { body } = document;
        let range;
        let sel;
        if (document.createRange && window.getSelection) {
            range = document.createRange();
            sel = window.getSelection();
            sel.removeAllRanges();
            try {
                range.selectNodeContents(el);
                sel.addRange(range);
            } catch (e) {
                range.selectNode(el);
                sel.addRange(range);
            }
        } else if (body.createTextRange) {
            range = body.createTextRange();
            range.moveToElementText(el);
            range.select();
        }
    }
}
